import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyLetters]',
})
export class OnlyLettersDirective {
  constructor(private readonly ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/[^a-zA-Z\s]/g, '');
    this.ngControl.control?.setValue(value, { emitEvent: false });
  }
}
